import React, {useContext, useEffect} from 'react';
import {TableWrapperContext} from './TableWrapper';
import {TrekerButton} from '../../pages/traffic/influence/bloggers/source/Treker/TrekerButton';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {useWindowWidth} from '../../hooks/useWindowWidth';

const FullScreen = () => {
  const windowWidth = useWindowWidth();
  const theme = useResolvedThemeMode();

  const {setFullMode, fullMode} = useContext(TableWrapperContext);

  return (
    <>
      {windowWidth > 720 && (
        <OverlayTrigger
          delay={{hide: 450, show: 300}}
          placement='top'
          overlay={(props) => (
            <Tooltip className='fs-8' {...props}>
              На весь экран
            </Tooltip>
          )}
        >
          <div>
            <TrekerButton
              svg={
                !fullMode ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    enableBackground='new 0 0 48 48'
                    width='15'
                    height='16'
                    id='Layer_4'
                    version='1.1'
                    viewBox='0 0 48 48'
                    xmlSpace='preserve'
                  >
                    <g>
                      <polygon points='20.539,16.826 9.877,6.164 16.02,0 0,0 0,16.074 6.222,9.831 16.877,20.486  '></polygon>
                      <polygon points='27.462,16.826 38.123,6.164 31.981,0 48,0 48,16.074 41.778,9.831 31.123,20.486  '></polygon>
                      <polygon points='27.462,31.176 38.123,41.838 31.981,48.002 48,48.002 48,31.927 41.778,38.17 31.123,27.516  '></polygon>
                      <polygon points='20.539,31.176 9.878,41.838 16.02,48.002 0.001,48.002 0.001,31.927 6.223,38.17 16.877,27.516     '></polygon>
                    </g>
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    enableBackground='new 0 0 48 48'
                    width='15'
                    height='16'
                    id='Layer_4'
                    version='1.1'
                    viewBox='0 0 48 48'
                    xmlSpace='preserve'
                  >
                    <g>
                      <polygon points='0,44.34 10.662,33.678 4.52,27.514 20.539,27.514 20.539,43.588 14.316,37.345 3.662,48  '></polygon>
                      <polygon points='47.999,44.34 37.338,33.678 43.479,27.514 27.461,27.514 27.461,43.588 33.683,37.345 44.338,48     '></polygon>
                      <polygon points='47.999,3.66 37.338,14.322 43.479,20.486 27.461,20.486 27.461,4.411 33.683,10.654 44.338,0  '></polygon>
                      <polygon points='0.001,3.66 10.662,14.322 4.521,20.486 20.539,20.486 20.539,4.411 14.317,10.654 3.663,0  '></polygon>
                    </g>
                  </svg>
                )
              }
              style={{
                height: '40px',
                gap: '0',
                backgroundColor:
                  theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
              }}
              onClick={() => {
                setFullMode((prev) => !prev);
              }}
            />
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};

export default FullScreen;
